import { render } from "./ReportComponent.vue?vue&type=template&id=60997668&scoped=true"
import script from "./ReportComponent.vue?vue&type=script&lang=js"
export * from "./ReportComponent.vue?vue&type=script&lang=js"

import "./ReportComponent.vue?vue&type=style&index=0&id=60997668&scoped=true&lang=css"

import exportComponent from "/Users/dmitriy-pc/Projects/ds-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60997668"]])

export default __exports__